<!-- <div style="height:100%;overflow-y: auto;"> -->
   <router-outlet></router-outlet>
<!-- </div> -->

<!-- <div class="fullscreen-spinner" *ngIf="loading">
   <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
     <span class="sr-only">Loading...</span>
   </div>
 </div> -->